import { defineStyleConfig } from "@chakra-ui/react";

export const Table= defineStyleConfig({
  variants: {
    simple: {
      tbody: {
        tr: {
          '&:nth-of-type(odd)': {
            td: {
              background: 'white',
            },
          },
          '&:nth-of-type(even)': {
            td: {
              background: 'gray.50',
            },
          },
        },
      },
    }
  }
});